export default __webpack_public_path__ + "static/media/bar_01.9dd55efa.svg";